import { useContext } from 'react'
import { ApprovalsContext } from 'contexts/approvalsContext'

export const useApprovalsContext = () => useContext(ApprovalsContext)
